import Cookies from "js-cookie";

const TokenKey = `${process.env.VUE_APP_NAME}-token`;

export default {
	getToken() {
		return Cookies.get(TokenKey);
	},
	
	setToken(token) {
		// Cookies.set(TokenKey, token, { path: process.env.BASE_URL, expires: 7 });
		Cookies.set(TokenKey, token, {expires: 30});
	},
	
	removeToken() {
		// Cookies.remove(TokenKey, { path: process.env.BASE_URL });
		Cookies.remove(TokenKey);
	}
};
